import z from 'zod';
import { IAIRecord } from './aiInterface';
import { Draft } from '../../common';
import { getSchema as getOrgSchema } from '../orgSchema';

export const AISchema = z.object({
  aiCode: z.string().min(6).optional(),
  aiCategoryCd: z.number().refine((val) => { return [1, 2].includes(val); },
    {
      message: "Category Code must be either AI or AIA"
    }
  ),
  aiMergedCode: z.string().min(6).optional(),
  apEligibilityInd: z.boolean(),
  psatEligibilityInd: z.boolean(),
  satEligibilityInd: z.boolean(),
  clepEligibilityInd: z.boolean(),
  ssdEligibilityInd: z.boolean(),
  annualReviewInd: z.boolean(),
  stateHomeSchoolInd: z.boolean(),
  crossPrgSecHoldInd: z.boolean(),
  aiStatusCd: z.number().refine((val) => { return [1, 2].includes(val); },
    {
      message: "Status must be either active or inactive"
    }
  ),
  aiLevelCd: z.number().refine((val) => { return [1, 2].includes(val); },
    {
      message: "AI Level must either be 1 of 2"
    }
  ),
  initialIngestionPathCd: z.number().refine((val) => { return [1, 2].includes(val); },
    {
      message: "Ingestion Path Code must be valid."
    }
  ),
});

export const AIRecord = z.object({
  ai: AISchema
});

export const getSchema = (update: Draft<IAIRecord>, preparing: boolean) => {
  return AIRecord.extend({
    org: getOrgSchema(update.org || {}, preparing,'ai')
  });
};